import { getSession } from 'utils/auth'
import { useSatuEventTracker } from 'utils/satuEvent'

const SATU_EVENT_NAME = 'guru_skp_pelaksanaan_fe_user_action_v1'

export type ScreenName =
  | 'penilaian_periodik_pegawai_list'
  | 'penilaian_periodik'

export type ActivityType =
  | 'choose_period'
  | 'choose_satdik'
  | 'confirm_send_to_ekin'
  | 'open_homepage'
  | 'open_penilaian_bulk'
  | 'open_penilaian_detail'
  | 'penilaian_periodik_survey'
  | 'send_to_ekin'
  | 'submit_penilaian_bulk'
  | 'submit_penilaian_detail'

type TrackerParams = {
  activity_type: ActivityType
  event_trigger?: ScreenName
  screen_name: ScreenName
  attributes?: TrackerParamAttributes
}

type TrackerParamAttributes = Partial<{
  ptk_id: string
  month: number
  year: number
  npsn: string
  role: 'dinas' | 'ks'
  periodikType: string
  surveyValue: string
  system_type: 'rekomendasi' | 'manual'
}>

const usePenilaianPeriodikTrackEvent = () => {
  const { SETrackEvent, SETransformAttrs } = useSatuEventTracker()
  const session = getSession()

  const trackEvent = (params: TrackerParams) => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        ...params,
        event_trigger: params.event_trigger ?? params.screen_name,
        attributes: SETransformAttrs({
          ...params?.attributes,
        }),
        event_trace_id: '',
      },
      sendUserData: true,
      sendDefaultParams: true,
      sendAttributes: false,
    })
  }

  const trackEventWithPtkId = (params: TrackerParams) => {
    const paramsWithPtkId = {
      ...params,
      attributes: { ptk_id: session?.user?.ptkId, ...params.attributes },
    }

    trackEvent(paramsWithPtkId)
  }

  return {
    trackEvent,
    trackEventWithPtkId,
  }
}

export default usePenilaianPeriodikTrackEvent
